import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgApplicationOrchestrationService = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-application-orchestration-service';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.34 3.282c-2.056.14-4.026 1.046-5.521 2.538-1.344 1.343-2.192 3.027-2.485 4.94-.096.629-.096 1.849 0 2.48.379 2.482 1.698 4.632 3.699 6.031.161.112.314.212.34.222s-.232.299-.573.643l-.619.624H9.76v-3.579l-.621.619-.62.62-.223-.12c-.611-.329-1.575-1.199-2.062-1.86a7.7 7.7 0 0 1-1.36-3.1c-.075-.399-.091-.622-.092-1.32-.002-.879.025-1.116.205-1.84.435-1.746 1.626-3.358 3.206-4.338a6.97 6.97 0 0 1 3.357-1.068l.45-.026V3.24l-.11.006c-.06.003-.308.019-.55.036m2.9 1.748v1.789l.618-.617c.71-.709.596-.677 1.138-.315.444.297.783.582 1.19 1.003 1.141 1.179 1.834 2.676 2.019 4.357.055.5.023 1.52-.062 1.985a7.26 7.26 0 0 1-2.023 3.88c-1.253 1.259-2.939 2.029-4.63 2.115l-.49.025v1.508h.15c.7-.001 1.814-.198 2.61-.463a8.6 8.6 0 0 0 3.421-2.116 8.75 8.75 0 0 0 1.877-9.608 8.85 8.85 0 0 0-1.982-2.92c-.489-.477-.751-.685-1.474-1.164-.01-.006.26-.29.599-.63l.618-.619H14.24zM9.531 7.81c-.104.135-2.371 4.147-2.37 4.195.001.03.537.991 1.192 2.135l1.19 2.08h4.914l1.19-2.08c.655-1.144 1.191-2.107 1.191-2.14s-.536-.996-1.191-2.14l-1.19-2.08-2.443-.01c-1.925-.008-2.452 0-2.483.04m4.812 2.81.788 1.38-.788 1.38-.788 1.38h-3.11l-.788-1.38L8.869 12l.788-1.38.788-1.38h3.11zm-2.757.2a1.33 1.33 0 0 0-.75.741c-.305.803.302 1.679 1.164 1.679.342 0 .629-.12.874-.366a1.24 1.24 0 0 0-.345-2c-.235-.115-.71-.142-.943-.054m.581 1.006c.152.138.045.414-.16.414a.243.243 0 0 1-.181-.407c.083-.091.244-.094.341-.007"
    })
  }));
});
export default SvgApplicationOrchestrationService;